// ルーティング設定

import { createBrowserRouter, RouteObject } from 'react-router-dom';
import Layout from '../components/Layout';
import { ProtectedRoute } from '../components/ProtectedRoute';
import HomePage from '../pages/HomePage';
import FileUploadPage from '../pages/FileUploadPage';
import CompanyInfoPage from '../pages/CompanyInfoPage';
import BCPCreatePage from '../pages/BCPCreatePage';
import IntroductoryBCPCreatePage from '../pages/IntroductoryBCPCreatePage';
import RestorePolicyPage from '../pages/RestorePolicyPage';
import BCPRegulationPage from '../pages/BCPRegulationPage';
import InitialResponsePage from '../pages/InitialResponsePage';
import ProcedureManualPage from '../pages/ProcedureManualPage';
import NotFoundPage from '../pages/NotFoundPage';
import AuthCallbackPage from '../pages/AuthCallbackPage';
import AuthErrorPage from '../pages/AuthErrorPage';
import SettingsPage from '../pages/SettingsPage';
import InquiryPage from '../pages/InquiryPage';
import TermsPage from '../pages/TermsPage';

// ルート定義
const routes: RouteObject[] = [
  // ホームページ（認証必須）
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <HomePage />
      </ProtectedRoute>
    ),
  },
  // 認証コールバック（認証不要）
  {
    path: '/auth/start',
    element: <AuthCallbackPage />,
  },
  // 認証エラー（認証不要）
  {
    path: '/error',
    element: <AuthErrorPage />,
  },
  // アップロードページ以降は統一ヘッダーを持つ
  {
    path: '/upload',
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <FileUploadPage />,
      },
    ],
  },
  {
    path: '/company-info',
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <CompanyInfoPage />,
      },
    ],
  },
  {
    path: '/settings',
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <SettingsPage />,
      },
    ],
  },
  {
    path: '/inquiry',
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <InquiryPage />,
      },
    ],
  },
  {
    path: '/terms',
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <TermsPage />,
      },
    ],
  },
  // BCP作成ページは独自のレイアウトを持つため、独立配置
  {
    path: '/create-bcp',
    element: (
      <ProtectedRoute>
        <BCPCreatePage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/create-bcp-intro',
    element: (
      <ProtectedRoute>
        <IntroductoryBCPCreatePage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/restore-policy',
    element: (
      <ProtectedRoute>
        <RestorePolicyPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/bcp/:bcpId/restore-policy',
    element: (
      <ProtectedRoute>
        <RestorePolicyPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/bcp/:bcpId/regulation',
    element: (
      <ProtectedRoute>
        <BCPRegulationPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/bcp/:bcpId/initial-response',
    element: (
      <ProtectedRoute>
        <InitialResponsePage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/bcp/:bcpId/procedure-manual',
    element: (
      <ProtectedRoute>
        <ProcedureManualPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

// ルーター作成
export const router = createBrowserRouter(routes);

// ルート定数
export const ROUTES = {
  HOME: '/',
  UPLOAD: '/upload',
  COMPANY_INFO: '/company-info',
  SETTINGS: '/settings',
  INQUIRY: '/inquiry',
  TERMS: '/terms',
  AUTH_ERROR: '/error',
  CREATE_BCP: '/create-bcp',
  CREATE_BCP_INTRO: '/create-bcp-intro',
  RESTORE_POLICY_SIMPLE: '/restore-policy',
  RESTORE_POLICY: (bcpId: string) => `/bcp/${bcpId}/restore-policy`,
  BCP_REGULATION: (bcpId: string) => `/bcp/${bcpId}/regulation`,
  INITIAL_RESPONSE: (bcpId: string) => `/bcp/${bcpId}/initial-response`,
  PROCEDURE_MANUAL: (bcpId: string) => `/bcp/${bcpId}/procedure-manual`,
} as const;

export type Route = typeof ROUTES[keyof typeof ROUTES];
